import { Component, inject, model } from '@angular/core';
import { ImagesService } from '../services/images.service';
import { ActivatedRoute } from '@angular/router';
import { AccessService } from '../../core/services/access.service';
import { ImageModel } from '../../shared/models/image.model';
import { ImagesFormComponent } from '../images-form/images-form.component';
import { Image } from '../models/image.model';
import { ImageInterface } from '../interfaces/image.interface';

@Component({
  selector: 'app-images-edit',
  standalone: true,
  imports: [ImagesFormComponent],
  templateUrl: './images-edit.component.html',
  styleUrl: './images-edit.component.css',
})
export class ImagesEditComponent {
  private service = inject(ImagesService);
  private route = inject(ActivatedRoute);
  protected access = inject(AccessService).access;

  protected id!: string | null;

  protected value = model<Image | undefined>(undefined);

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Editar Imagen');
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    // console.log('getContract', id)
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.get(id).subscribe((data) => {
        this.value.update((value) => {
          value = Image.from(data as ImageInterface);
          // console.log('imagen: ', value)
          return value;
        });
      });
    }
  }
}
